import { apiRequest } from './client.js';

export interface ClientSummary {
  id: string;
  name: string;
  rnc: string | null;
  sector: string | null;
  archived_at: string | null;
  created_at: string;
}

export interface ClientDetail extends ClientSummary {
  contact_data: Record<string, unknown>;
}

export const clientsApi = {
  list: (search?: string) =>
    apiRequest<{ clients: ClientSummary[] }>(
      `/api/v1/clients${search ? `?search=${encodeURIComponent(search)}` : ''}`,
    ),
  create: (input: { name: string; rnc?: string; sector?: string }) =>
    apiRequest<ClientDetail>('/api/v1/clients', { method: 'POST', body: input }),
  get: (id: string) => apiRequest<ClientDetail>(`/api/v1/clients/${id}`),
};
